module.exports = __webpack_public_path__ + "img/icon-points3.d0ffc331.png";